"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/** @ignore */
var DOWN_ARROW = exports.DOWN_ARROW = 40;

/** @ignore */
var LEFT_ARROW = exports.LEFT_ARROW = 37;

/** @ignore */
var RIGHT_ARROW = exports.RIGHT_ARROW = 39;

/** @ignore */
var UP_ARROW = exports.UP_ARROW = 38;
//# sourceMappingURL=key-codes.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-input-range/lib/js/input-range/key-codes.js
 ** module id = 1024
 ** module chunks = 0
 **/